// @flow
import $ from 'jquery';
import _ from 'lodash';

type EventOptions = {
  event: string,
  selector: string,
};

const generateEventName = (eventOptions: EventOptions) =>
  `${eventOptions.event}-${eventOptions.selector}`;

export const on = (eventOptions: EventOptions) => (
  target: any,
  name: string,
  descriptor: any,
) => {
  if (!target.withDelegateEvents) {
    target.withDelegateEvents = {};
  }

  if (_.isFunction(target.withDelegateEvents)) {
    throw new Error('The on decorator is not compatible with an events method');
  }

  if (!eventOptions) {
    throw new Error('The on decorator requires an eventOptions argument');
  }

  target.withDelegateEvents[generateEventName(eventOptions)] = {
    ...eventOptions,
    listenerName: name,
  };

  return descriptor;
};

// バリデーションエラー時のエラーメッセージを削除するメソッド
// simple_form_bootstrap.rbで定義しているwrapperによってis-invalidの要素とエラーメッセージの要素の階層が異なっている
// is-invalidの要素とエラーメッセージの要素が同じ階層にある場合から2つ上の階層にある場合まで分かれているので、どの場合でもエラーメッセージを削除できるよう定義している
export const removeInvalidFeedback = (target: any) => {
  const selector = '.invalid-feedback';
  target
    .parent()
    .children(selector)
    .remove();
  target
    .parent()
    .parent()
    .children(selector)
    .remove();
  target
    .parent()
    .parent()
    .parent()
    .children(selector)
    .remove();
};

export default class JQueryView {
  $el: any;
  el: string | Object;
  cid: string;

  constructor(el: string | Object) {
    this.el = el;
    this.$el = $(el);
    this.cid = _.uniqueId('c');
    this.delegateEvents();
  }

  get events(): Object {
    // $FlowFixMe
    return this.withDelegateEvents || {};
  }

  // prettier-ignore
  delegateEvents() {
    Object.keys(this.events || {}).forEach(key => {
      const { event, selector, listenerName } = this.events[key];
      const listener = _.isFunction(listenerName)
        ? listenerName
        : // $FlowFixMe
        this[listenerName];
      if (listener) this.delegate(event, selector, _.bind(listener, this));
    });
  }

  // prettier-ignore
  undelegateEvents() {
    Object.keys(this.events || {}).forEach(key => {
      const { event, selector, listenerName } = this.events[key];
      const listener = _.isFunction(listenerName)
        ? listenerName
        : // $FlowFixMe
        this[listenerName];
      if (listener) this.undelegate(event, selector);
    });
  }

  delegate(eventName: any, selector: any, listener: any) {
    if (selector === 'self') {
      this.$el.on(eventName, listener);
    } else {
      this.$el.on(`${eventName}.delegateEvents${this.cid}`, selector, listener);
    }
  }

  undelegate(eventName: any, selector: any) {
    if (selector === 'self') {
      this.$el.undelegate(eventName);
    } else {
      this.$el.undelegate(selector, `${eventName}.delegateEvents${this.cid}`);
    }
  }

  destroy() {
    this.undelegateEvents();
  }
}
